import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"

// Import only translation resources available in the app
// Note: we can also load these resources from a server
// e.g. https://cdn.getdashfuel.com/locales/en/translation.json
import enTranslation from "locales/en/translation.json"
import esTranslation from "locales/es/translation.json"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: process.env.NODE_ENV !== "production",
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
